export const PORTFOLIO_REVIEW_UNKNOWNS_FORM = 'portfolioReviewUnknownsForm';
export const PORTFOLIO_REVIEW_UNKNOWNS_FIELD_ARRAY = 'portfolio-review-unknowns-field-array';

export const UNKNOWN_BOND_VALUE = 'UNKNOWN_BOND_VALUE';

export const UNKNOWN_BOND_OPTION = { label: 'Don’t see your Bond? ', value: UNKNOWN_BOND_VALUE };
